import layout from './DetailViewView.html?raw';
import AsyncView from '@/Views/AsyncView';
import ComponentManager from '@/Management/ComponentManager';
import type DetailViewViewModel from '@/ViewModels/Views/DetailViewViewModel';
import { CustomBindingRenderHooks } from '#/DefaultViewExtensionInterfaces';
import type DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import type DetailViewGroupFactory from '@/Factories/GroupFactories/DetailViewGroupFactory';

export default class DetailViewView extends AsyncView {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: DetailViewViewModel, private element: JQuery<HTMLElement>, private customLayout?: string) {
        super();
    }

    public async getElementAsync(): Promise<JQuery> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, this.customLayout || layout);

        return this.view;
    }

    public getDvgItemRenderHooks(): CustomBindingRenderHooks<DetailViewGroupFactory, DetailViewContext> {
        return {
            beforeRender: (factory, dvc) => {
                this.viewModel.increaseBusyCounter();
            },
            afterRender: (factory, dvc) => {
                if (this.isDisposed || this.viewModel.isDisposed)
                    return;

                this.viewModel.decreaseBusyCounter();

                factory.onAfterRender();
            },
            onFailure: (factory, data, error) => {
                if (this.isDisposed || this.viewModel.isDisposed)
                    return;

                this.viewModel.decreaseBusyCounter();
            }
        }
    }
}

ComponentManager.setView('DetailViewView', DetailViewView, 'RADPresentation.HTMLClient.DefaultViewExtensions');